import moment from 'moment';
import { isEmpty, difference } from 'lodash';

const _ = { isEmpty, difference };

export const ComparatorTypes = {
    DATE: 'date',
    FORMATTED_DATE: 'formatted_date',
    STRING: 'string',
    NUMBER: 'number',
};

const compareString = (a, b, field, descend) => {
    if (field) {
        if (a[field] && b[field]) {
            if (descend) {
                return b[field].localeCompare(a[field]);
            }
            return a[field].localeCompare(b[field]);
        } if (a[field]) {
            return descend ? -1 : 1;
        } if (b[field]) {
            return descend ? 1 : -1;
        }
        return 0;
    }
    return 0;
};

const compareNumber = (a, b, field, descend) => {
    if (field) {
        if (a[field] && b[field]) {
            if (descend) {
                return b[field] - a[field];
            }
            return a[field] - b[field];
        } if (a[field]) {
            return descend ? -1 : 1;
        } if (b[field]) {
            return descend ? 1 : -1;
        }
        return 0;
    }
    return 0;
};

const compareFormattedDate = (a, b, field, descend) => {
    // Comparing Dates should be moment objects
    if (field && a[field] && b[field]) {
        const aDate = moment.utc(a[field]);
        const bDate = moment.utc(b[field]);
        if (aDate.isAfter(bDate)) {
            return descend ? -1 : 1;
        }
        if (aDate.isSame(bDate)) {
            return 0;
        }
        return descend ? 1 : -1;
    }
    return 0;
};

const compareDate = (a, b, field, descend) => {
    // Comparing Dates should be moment objects
    if (field && a[field] && b[field]) {
        if (a[field].isAfter(b[field])) {
            return descend ? -1 : 1;
        }
        if (a[field].isSame(b[field])) {
            return 0;
        }
        return descend ? 1 : -1;
    }
    return 0;
};

export const getGradClassValue = (gradClassName) => {
    switch (gradClassName) {
        case 'Freshman':
            return 1;
        case 'Sophomore':
            return 2;
        case 'Junior':
            return 3;
        case 'Senior':
            return 4;
        default:
            return 0;
    }
};

export const comparator = (types) => {
    return (a, b) => {
        if (types && types.length > 0) {
            let result = 0;
            types.every((type) => {
                switch (type.type) {
                    case ComparatorTypes.DATE:
                        result = compareDate(a, b, type.field, type.descend);
                        break;
                    case ComparatorTypes.FORMATTED_DATE:
                        result = compareFormattedDate(a, b, type.field, type.descend);
                        break;
                    case ComparatorTypes.STRING:
                        result = compareString(a, b, type.field, type.descend);
                        break;
                    case ComparatorTypes.NUMBER:
                        result = compareNumber(a, b, type.field, type.descend);
                        break;
                    default:
                        break;
                }
                return result === 0;
            });
            return result;
        }
        return 0;
    };
};

// checks if 2 arrays contain the same elements (order-independent)
export const arraysAreSame = (array1, array2) => {
    return _.isEmpty(_.difference(array1, array2)) && _.isEmpty(_.difference(array2, array1));
};
